// extracted by mini-css-extract-plugin
export default {"input":"elements_input__8NF-f","btn":"elements_btn__QJIM8","msg_error":"elements_msg_error__LM2CF","link_underlined":"elements_link_underlined__ZgX8N"};